/**
 * Avatar id list + guard — shared by the Avatar component and avatar-picker
 * UIs. Lives outside Avatar.tsx so that file only exports a component
 * (react-refresh/only-export-components).
 */

export type AvatarId =
  | 'thief' | 'hacker' | 'ninja' | 'chick'
  | 'robot' | 'french' | 'blonde' | 'hijab'
  | 'afro' | 'ginger' | 'astronaut' | 'chef'
  | 'pirate' | 'singer' | 'samurai' | 'navajo'
  | 'scientist' | 'skier' | 'pharaoh' | 'wizard'
  | 'builder' | 'alien' | 'ghost' | 'nun'
  | 'queen' | 'police' | 'fireman' | 'vampire'

export const AVATAR_IDS: AvatarId[] = [
  'thief', 'hacker', 'ninja', 'chick',
  'robot', 'french', 'blonde', 'hijab',
  'afro', 'ginger', 'astronaut', 'chef',
  'pirate', 'singer', 'samurai', 'navajo',
  'scientist', 'skier', 'pharaoh', 'wizard',
  'builder', 'alien', 'ghost', 'nun',
  'queen', 'police', 'fireman', 'vampire',
]

export function isAvatarId(value: string): value is AvatarId {
  return (AVATAR_IDS as string[]).includes(value)
}
